import { Icon } from "./icons/Icon";
import "./Meter.css";

interface MeterProps {
  readonly used: number;
  readonly limit: number;
}

/** 上限が近いとみなす割合。ここを越えると帯が金茶へ寄り、超過が近いことを予告する。 */
const NEARING_LIMIT_RATIO = 0.8;

/**
 * 手数メーター。「使用 n / 上限 m」を分母つきで表示し、増えていくバーで示す
 * （減っていく表現にしない）。超過時は縞のバー＋金茶の数字＋旗の印で示し、赤にしない
 * （ui-design.md §5.3・D-105）。
 *
 * D-116: 上限が近づいた時点（8割）で帯を金茶へ寄せ、超過を予告する。
 * 超過そのものの表現（縞・旗）は従来どおりで、**咎めの朱は使わない**（D-105）。
 */
export function Meter({ used, limit }: MeterProps) {
  const overLimit = used > limit;
  const nearing = !overLimit && limit > 0 && used / limit >= NEARING_LIMIT_RATIO;
  const fillPercent = limit > 0 ? Math.min((used / limit) * 100, 100) : 100;

  return (
    <div
      className={[
        "meter",
        nearing ? "meter--nearing" : null,
        overLimit ? "meter--over-limit" : null,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span className="meter__count">
        手数 {used} / {limit}
      </span>
      <span className="meter__bar-track">
        <span className="meter__bar-fill" style={{ width: `${fillPercent}%` }} />
      </span>
      {overLimit && <Icon name="flag" decorative size={16} />}
    </div>
  );
}
